var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-page-template',{attrs:{"title":"Password Reset","img":""}},[_c('close-button'),_c('password-reset-form',{attrs:{"label":"Set Password"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }